module.exports = __webpack_public_path__ + "static/img/h6-3.5e32e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/h6-3.png
// module id = tsnE
// module chunks = 1